export default __webpack_public_path__ + "static/media/naPratica.55a114dd.svg";